import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../slices/authSlice'; // 경로가 다르면 수정하세요!
import { styles as topicStyles } from './Topics/TopicStyles';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  
  // 리덕스에서 로그인 정보 가져오기
  const { isAuthenticated, user } = useSelector(state => state.auth);

  const unreadCount = user?.unreadPostIds?.length || 0;

  const handleLogout = () => {
    if (window.confirm("전장을 이탈하시겠습니까? (로그아웃)")) {
      dispatch(logout());
      alert("정상적으로 이탈 처리되었습니다.");
      navigate('/login');
    }
  };

  return (
  <>
    <nav style={styles.nav}>
      {/* 왼쪽: 로고 (클릭 시 홈으로) */}
      <div style={styles.logoSection}>
        <Link to="/" style={styles.logo}>THE PIVOT</Link>

        {/*<button onClick={() => setIsRulesOpen(true)} style={styles.rulesBtn}>RULES</button>*/}
        <button onClick={() => setIsRulesOpen(true)} style={{...styles.logoutBtn, border: '#00d4ff', color: '#00d4ff' }}>RULES(게시판 안내)</button>
      </div>

      {/* 오른쪽: 유저 정보 및 메뉴 */}
      <div style={styles.menuSection}>
        {isAuthenticated ? (
          <>
            <span style={styles.userBadge}>
              {user?.role === 'ADMIN' && <span style={styles.adminTag}>[ADMIN] </span>}
              {user?.nickname} 논객 | <span style={{color: '#ffd700'}}>{user?.points?.toLocaleString()} P</span>
            </span>

            {/* 관리자 전용 대시보드 링크 추가 */}
            {user?.role === 'ADMIN' && (
              <Link to="/admin" style={{...styles.loginLink, color: '#ff4d4d', marginRight: '1.5rem'}}>ADMIN DASHBOARD</Link>
            )}
            
            {/* 🚩 [수정] 마이페이지 링크 + 숫자 배지(Badge) */}
            <Link to="/mypage" style={{...styles.loginLink, color: '#fff', marginRight: '1.5rem', position: 'relative'}}>
              MY PAGE
              
              {unreadCount > 0 && (
                <span style={styles.notificationBadge}>
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </Link>

            <button onClick={handleLogout} style={styles.logoutBtn}>LOGOUT</button>
          </>
        ) : (
          <Link to="/login" style={styles.loginLink}>LOGIN</Link>
        )}
      </div>
    </nav>

    {/* RULES 모달 */}
    {isRulesOpen && (
        <div style={topicStyles.rulesOverlay} onClick={() => setIsRulesOpen(false)}>
          <div style={topicStyles.rulesContent} onClick={e => e.stopPropagation()}>
            <div style={topicStyles.modalHeader}>
              <h2 style={{margin: 0, fontSize: '1.2rem'}}>THE PIVOT : 교전 수칙</h2>
              <button style={topicStyles.closeBtn} onClick={() => setIsRulesOpen(false)}>✕</button>
            </div>
            <div style={topicStyles.rulesBody}>

              <h1 style={topicStyles.rulesTitle}>THE PIVOT 이용 수칙</h1>
              <h2 style={topicStyles.rulesSubtitle}>"유튜브의 무지성 댓글창을 벗어나, 정교한 논리가 승리하는 전장으로."</h2>
              
              <div style={topicStyles.rulesSection}>
                <div style={topicStyles.rulesSectionTitle}>1. 전장 개요</div>
                <p>THE PIVOT은 단순한 게시판이 아닙니다. 비난과 조롱을 걷어낸, 순수 이성 토론장입니다. 품격 있는 전장 환경을 위해 아래 수칙을 반드시 숙지하십시오.</p>
              </div>

              <div style={topicStyles.rulesSection}>
                <div style={topicStyles.rulesSectionTitle}>2. 포인트 시스템 (보급) - 포인트 충전은 MY PAGE에서 가능.(사용기한 1년)</div>
                <table style={topicStyles.rulesTable}>
                  <tbody>
                    <tr><td style={topicStyles.rulesTableTd}>최초 가입 보급</td><td style={topicStyles.rulesTableTd}>+ 5,000 P</td></tr>
                    <tr><td style={topicStyles.rulesTableTd}>전장(게시판) 참여</td><td style={topicStyles.rulesTableTd}>- 3,000 P (게시판 1개 당 최초 1회)</td></tr>
                    <tr><td style={topicStyles.rulesTableTd}>진영 변경</td><td style={topicStyles.rulesTableTd}>- 100 P (횟수 제한 없음)</td></tr>
                    <tr><td style={topicStyles.rulesTableTd}>콘텐츠 신고</td><td style={topicStyles.rulesTableTd}>- 30 P (무분별한 신고 방지 및 클린 환경 조성)</td></tr>
                  </tbody>
                </table>
              </div>

              <div style={topicStyles.rulesSection}>
                <div style={topicStyles.rulesSectionTitle}>3. 진영 논리 (BLUE vs RED)</div>
                <div>모든 전장은 두 진영으로 나뉩니다. 본인의 논리에 맞는 진영을 선택하십시오.</div>
                <ul>
                  <li><strong>진영 일치 원칙:</strong> 본인이 속한 진영의 논리에 부합하는 게시글과 댓글만 작성할 수 있습니다.(상대 발언에 관한 질문 및 진영에 크게 벗어나지 않는 경우는 허용됩니다.)</li>
                  <li><strong>교차 검증(신고):</strong> 소속 진영과 명백히 상반되는 내용을 올릴 경우, 관리자에 의해 경고없이 블라인드 처리 또는 타 이용자에 의해 신고당할 수 있습니다. 신고가 다수 누적된 게시글/댓글은 관리자의 심사 대상이 됩니다.</li>
                  <li><strong>진영 변경:</strong> 생각이 바뀌었다면 언제든 진영을 옮길 수 있으나, <span style={topicStyles.important}>100 P</span>가 소모됩니다.</li>
                </ul>
              </div>

              <div style={topicStyles.rulesSection}>
                <div style={topicStyles.rulesSectionTitle}>4. 전장 정화 (신고 및 블라인드)</div>
                <div>무지성 비난과 조롱은 제재를 받을 수 있습니다.</div>

                <ul>
                  <li><strong>관리자 직접 제재:</strong> 도배, 욕설, 조롱, 근거 없는 비난, 소속 진영에 명백히 반하는 내용 등은 신고 수와 무관하게 관리자에 의해 즉시 <span style={topicStyles.important}>블라인드(숨김)</span>처리될 수 있습니다.</li>
                  <li><strong>민주적 심사:</strong> 일정 수 이상의 신고를 받은 게시물/댓글은 관리자의 심사대상이 됩니다.</li>

                    <ul>
                      <li><strong>신고 인정:</strong> 게시물 영구 블라인드 처리.</li>
                      <li><strong>신고 반려:</strong> 게시물 원상 복구.</li>
                    </ul>

                  <li><strong>신고의 책임:</strong> 문제없는 글을 악의적으로 신고하는 행위 역시 제재 대상이 될 수 있습니다.</li>
                </ul>

                <div>관리자의 판단에 따라 특정 세력의 조직적인 '신고 테러'가 의심될 경우, 신고 기능 이용이 일시 제한될 수 있습니다.</div>

              </div>

              <div style={topicStyles.rulesSection}>
                <div style={topicStyles.rulesSectionTitle}>5. 승패 결정 및 보상 (MVP)</div>
                <div>전쟁의 승리는 '목소리 크기'가 아니라 <span style={topicStyles.important}>상대 진영의 인정</span>으로 결정됩니다.</div>

                <ul>
                  <li><strong>결산 주기:</strong> 매주 1회 (일주일 단위 / 모든 게시판(전장) 개별 적용)</li>
                  <li><strong>승리 기준:</strong> 우리 진영이 <span style={topicStyles.important}>'상대 진영'으로부터 받은 하트(좋아요) 수</span>의 총합이 더 높은 쪽이 승리합니다.</li>

                    <div>결국, 철저한 논리로 적진을 설득시키는 진영이 전장을 지배합니다.</div>

                  <li><strong>실시간 전황:</strong> 전장 상단의 게이지를 통해 양 진영의 우세 정도를 실시간으로 확인할 수 있습니다.</li>
                  <li><strong>MVP 선발:</strong> 승리 진영 중 가장 많은 하트를 획득한 논객은 해당 주차의 <span style={topicStyles.important}>MVP</span>로 선정되며, 3000P의 보상이 지급됩니다.</li>
                </ul>
              </div>

              <div style={topicStyles.rulesSection}>
                <div style={topicStyles.rulesSectionTitle}>6. 하트(좋아요) 사용법</div>
                
                <ul>
                  <li><strong>진영의 자부심:</strong> 본인이 속한 진영의 하트만 누를 수 있습니다.</li>
                  <li><strong>중복 방지:</strong> 게시물/댓글 1개당 1번만 가능하며, 취소할 수 있습니다.</li>
                  <li><strong>자유 투표:</strong> 한 게시글에 양측 진영의 하트가 동시에 달릴 수 있습니다. 이는 해당 글이 양쪽 모두에게 논리적으로 설득력이 있음을 의미합니다.</li>
                </ul>
              </div>

              <div style={topicStyles.rulesSection}>
                <div style={topicStyles.rulesSectionTitle}>*건전한 게시판 분위기를 위해 게시한 내용은 AI에 의해 오염도가 측정됩니다.(참고용)</div>
              </div>

            </div>
          </div>
        </div>
    )}
  </>
  );
};

const styles = {
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 2rem',
    height: '60px',
    backgroundColor: '#000',
    borderBottom: '1px solid #333',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  logo: {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '1.5rem',
    fontWeight: '900',
    letterSpacing: '2px',
  },
  userBadge: {
    color: '#ccc',
    marginRight: '1.5rem',
    fontSize: '0.9rem',
  },
  adminTag: {
    color: '#ff4d4d',
    fontWeight: 'bold',
  },
  logoutBtn: {
    backgroundColor: 'transparent',
    border: '1px solid #ff4d4d',
    color: '#ff4d4d',
    padding: '5px 15px',
    cursor: 'pointer',
    borderRadius: '3px',
    transition: '0.3s',
  },
  loginLink: {
    color: '#007bff',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },

  rulesBtn: {
    backgroundColor: 'rgba(0, 212, 255, 0.08)', // 은은한 블루 배경 상시 유지
    border: '2px solid #00d4ff',                // 선명한 네온 블루 테두리
    color: '#00d4ff',                           // 네온 블루 텍스트
    
    padding: '6px 16px',
    marginLeft: '2rem',
    fontSize: '0.85rem',
    fontWeight: '900',
    letterSpacing: '1.5px',
    cursor: 'pointer',
    borderRadius: '4px',
    
    // ✨ 상시 발광 효과: 테두리 밖으로 퍼지는 광원 + 안쪽으로 스며드는 광원
    boxShadow: '0 0 15px rgba(0, 212, 255, 0.6), inset 0 0 8px rgba(0, 212, 255, 0.4)',
    textShadow: '0 0 10px rgba(0, 212, 255, 0.8)', // 글자 자체도 상시 빛남
    
    textTransform: 'uppercase',
    outline: 'none',
    transition: 'none', // 효과 변화가 없으므로 transition 제거
  },

  // 🚩 [추가] 숫자 배지 스타일 (인스타/페이스북 스타일)
  notificationBadge: {
    position: 'absolute',
    top: '-8px',         // 텍스트보다 살짝 위에
    right: '-12px',      // 텍스트 오른쪽 끝에
    backgroundColor: '#ff4e50', // 강렬한 빨강
    color: 'white',
    borderRadius: '50%', // 동그라미
    padding: '2px 6px',  // 숫자 주변 여백
    fontSize: '0.7rem',  // 작은 글씨
    fontWeight: 'bold',
    minWidth: '18px',    // 최소 너비 확보 (숫자 1개일 때 찌그러짐 방지)
    textAlign: 'center',
    boxShadow: '0 0 5px rgba(255, 78, 80, 0.6)' // 살짝 빛나게
  }
};

export default Navbar;